<script setup lang="ts">
import { provide } from 'vue';

import { PhxsgAccordion as PhxsgCoreAccordion } from '@sg-core/src/View/Components/Molecules/Accordion';
import type { PhxsgAccordionProps, PhxsgAccordionValue } from '@sg-core/src/View/Components/Molecules/Accordion';

import { PhxsgButton } from '../../Atoms/Button';

const props = defineProps<PhxsgAccordionProps>();

const model = defineModel<PhxsgAccordionValue>({ default: null });

provide('PhxsgButton', PhxsgButton);
</script>

<template>
  <PhxsgCoreAccordion v-bind="props" v-model="model">
    <slot />
  </PhxsgCoreAccordion>
</template>

<style src="./accordion.css" />
